"use strict";
/*
 * Created on 09 02 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SiteReleaseItem}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseItemConverter, _DataObjectConverter_);

  function SiteReleaseItemConverter() {
    _classCallCheck(this, SiteReleaseItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItemConverter).apply(this, arguments));
  }

  return SiteReleaseItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseItemConverter = SiteReleaseItemConverter;